import React from "react";

export const joinElements = (data: React.ReactNode[], separator: React.ReactNode = ", "): React.ReactNode[] => {
  return data.flatMap((t, i) => [
    ...(i ? [<React.Fragment key={i + data.length}>{separator}</React.Fragment>] : []),
    <React.Fragment key={i}>{t}</React.Fragment>,
  ]);
};
